import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal, message, Divider, Button, Switch, Popconfirm } from "antd";
import { DownloadOutlined, PlusOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
import InspectionApi from '@api/inspectionnew'
import { stationApi, } from "@api/newApi";
import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { setStateSearchParams } from '@store/actions/common'
import { getStationData, cycleKey } from '@utils/common'
import AddModel from './add'
import '../style.scss'

const PlanCom = (props) => {
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editTitle, setEditTitle] = useState('新建巡检计划')
  const [rowParams, setRowParams] = useState()
  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  })
  const [total, setTotal] = useState(0)


  // 搜索
  // const [inputList] = useState([{
  //   label: '厂站:',
  //   name: "stationId",
  //   message: "请输入部门ID",
  //   span: 8,
  //   labelCol: 6
  // }])
  const [selectList, setSelectList] = useState()

  const [stationData, setStationData] = useState()

  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '厂站:',
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6
      },
      {
        attr: { allowClear: true },
        label: '状态:',
        name: "status",
        message: "请选择状态",
        options: [{ title: '停用', value: 0, checked: false }, { title: '启用', value: 1, checked: false }],
        span: 8,
        labelCol: 6
      },
    ])
    setStationData(data)
  }

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    // const statinIds = userInfo.stationIds ? userInfo.stationIds.split(",") : []
    InspectionApi.planList({ ...searchParams, }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data.data || [])
        setTotal(res.total)
      }
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
    }
    setSearchParams(params)
  }

  /**
  * 删除规则
  */
  const deletes = (id) => {
    setLoadBtn(true)
    InspectionApi.planDel(id).then(res => {
      setLoadBtn(false)
      if (res.status == 0) {
        setDelVisible(false)
        setRowParams(null)
        listByRole()
        message.success("删除成功！")
      }
    }).catch(err => {
      setLoadBtn(false)
    })
  }

  const cancelDel = (bool) => {
    setDelVisible(false)
    // setParams({})
  }
  // 改变状态
  const handleConfirm = (info) => {
    if(info.status === 1){
      InspectionApi.planDisenable({id:info.id}).then(res => {
        if (res.status === '0') {
          message.success('修改成功')
          listByRole()
        }
      })
    } else {
      InspectionApi.planEnable({id:info.id}).then(res => {
        if (res.status === '0') {
          message.success('修改成功')
          listByRole()
        }
      })
    }
    
  }


  const btnList = [{
    title: "新增",
    type: 'primary',
    icon: <PlusOutlined />,
    onClick: () => {      
      setRowParams({patrolPlanPeriodAddDTOS:[{period:'',weekDay:'',month:'',time:[],day:'',date:0}],patrolPlanPeriodPOS:[]})
      setEditTitle('新增巡检计划')
      setEditVisible(true)
    }
  }]

  const columns = [
    {
      title: '巡检计划名称',
      dataIndex: 'planName',
      align: 'center',
      key: 'planName',
      width: '200',
    },
    {
      title: '所属厂站',
      dataIndex: 'stationAliasName',
      align: 'center',
      key: 'stationAliasName',
      width: '80',
    },
    {
      title: '所属标准',
      dataIndex: 'tandardName',
      align: 'center',
      key: 'tandardName',
      width: '80',
    },
    {
      title: '人员',
      dataIndex: 'createByName',
      align: 'center',
      key: 'createByName',
      width: '80',
    },
    {
      title: '巡检周期',
      dataIndex: 'cycle',
      align: 'center',
      key: 'cycle',
      width: '80',
      // 天周月季度某天
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      key: 'status',
      width: 80,
      render: (obj, record) => {
        return <span style={{ color: obj !== 0 ? 'green' : 'red' }}> {obj !== 0 ? '启用' : '禁用'}</span>
      }
    },

    {
      title: '开始时间',
      dataIndex: 'beginTime',
      align: 'center',
      key: 'beginTime',
      width: '200',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '结束开始时间',
      dataIndex: 'endTime',
      align: 'center',
      key: 'endTime',
      width: '200',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    // {
    //   title: '创建人',
    //   dataIndex: 'createName',
    //   align: 'center',
    //   // width: '100',
    //   key: 'createName',
    // },

    // {
    //   title: '创建时间',
    //   dataIndex: 'createAt',
    //   align: 'center',
    //   key: 'createAt',
    //   width: '200',
    //   render: (obj) => {
    //     if (obj) {
    //       return (
    //         moment(obj).format('YYYY-MM-DD HH:mm:ss')
    //       )
    //     }
    //   }
    // },

    {
      title: '操作',
      key: 'operation',
      width: '200',
      align: 'center',
      fixed: 'right',
      render: (obj, record) => {
        return (
          <>

            <Popconfirm
              title={`确定要${obj.status === 0 ? '启用' : '禁用'}计划吗？`}
              onConfirm={() => handleConfirm(record)}
              // onCancel={cancel}
              okText="确定"
              cancelText="取消"
            >
              <Button style={{ margin: '0 5px' }} size='small' type="primary">{obj.status === 0 ? '启用' : '禁用'}</Button>
            </Popconfirm>
             <Button style={{ margin: '0 5px' }} onClick={() => {
              setEditVisible(true)
              setEditTitle('编辑巡检计划')
              setRowParams(record)
            }} size='small' type="primary">编辑</Button> 
            {/* <Button

              onClick={() => {
                setDelVisible(true)
                setRowParams(record)
              }
              }
              size='small'
              type='primary'>删除
            </Button> */}
          </>
        )
      }
    }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        {/* <Title title="厂站列表" style={{ marginLeft: '24px' }}></Title> */}
        <div style={{ marginLeft: '24px' }}>
          <SearchForm searchParams={searchParams} span={6} selectList={selectList} onSearch={search} />
        </div>
        <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} />
        <div >
          <Table
            className='Table'
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>

        {
          deleteVisible &&
          <Modal
            title='删除厂站'
            width={420}
            visible={deleteVisible}
            onCancel={cancelDel}
            confirmLoading={loadBtn}
            onOk={() => deletes(rowParams.id)}>
            <div style={{ textAlign: 'center', color: "red" }}>
              <p>{`确定要删除巡检计划【${rowParams.planName}】吗？`}</p>
            </div>
          </Modal>
        }
        {editVisible && <AddModel stationData={stationData} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(PlanCom)
